package com.iptvplayer.shared.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Double
import kotlin.Long
import kotlin.String

public class VodItemQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    sourceId: String,
    name: String,
    streamUrl: String,
    coverUrl: String?,
    plot: String?,
    genre: String?,
    duration: Long?,
    rating: Double?,
    groupName: String?,
  ) -> T): Query<T> = Query(-125_045_341, arrayOf("VodItemEntity"), driver, "VodItem.sq",
      "selectAll",
      "SELECT VodItemEntity.id, VodItemEntity.sourceId, VodItemEntity.name, VodItemEntity.streamUrl, VodItemEntity.coverUrl, VodItemEntity.plot, VodItemEntity.genre, VodItemEntity.duration, VodItemEntity.rating, VodItemEntity.groupName FROM VodItemEntity") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7),
      cursor.getDouble(8),
      cursor.getString(9)
    )
  }

  public fun selectAll(): Query<VodItemEntity> = selectAll { id, sourceId, name, streamUrl,
      coverUrl, plot, genre, duration, rating, groupName ->
    VodItemEntity(
      id,
      sourceId,
      name,
      streamUrl,
      coverUrl,
      plot,
      genre,
      duration,
      rating,
      groupName
    )
  }

  public fun <T : Any> selectBySourceId(sourceId: String, mapper: (
    id: String,
    sourceId: String,
    name: String,
    streamUrl: String,
    coverUrl: String?,
    plot: String?,
    genre: String?,
    duration: Long?,
    rating: Double?,
    groupName: String?,
  ) -> T): Query<T> = SelectBySourceIdQuery(sourceId) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7),
      cursor.getDouble(8),
      cursor.getString(9)
    )
  }

  public fun selectBySourceId(sourceId: String): Query<VodItemEntity> = selectBySourceId(sourceId) {
      id, sourceId_, name, streamUrl, coverUrl, plot, genre, duration, rating, groupName ->
    VodItemEntity(
      id,
      sourceId_,
      name,
      streamUrl,
      coverUrl,
      plot,
      genre,
      duration,
      rating,
      groupName
    )
  }

  public fun <T : Any> selectByGroup(groupName: String?, mapper: (
    id: String,
    sourceId: String,
    name: String,
    streamUrl: String,
    coverUrl: String?,
    plot: String?,
    genre: String?,
    duration: Long?,
    rating: Double?,
    groupName: String?,
  ) -> T): Query<T> = SelectByGroupQuery(groupName) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7),
      cursor.getDouble(8),
      cursor.getString(9)
    )
  }

  public fun selectByGroup(groupName: String?): Query<VodItemEntity> = selectByGroup(groupName) {
      id, sourceId, name, streamUrl, coverUrl, plot, genre, duration, rating, groupName_ ->
    VodItemEntity(
      id,
      sourceId,
      name,
      streamUrl,
      coverUrl,
      plot,
      genre,
      duration,
      rating,
      groupName_
    )
  }

  public fun selectGroups(): Query<String> = Query(-1_311_586_670, arrayOf("VodItemEntity"), driver,
      "VodItem.sq", "selectGroups",
      "SELECT DISTINCT groupName FROM VodItemEntity WHERE groupName IS NOT NULL ORDER BY groupName") {
      cursor ->
    cursor.getString(0)!!
  }

  public fun <T : Any> search(`value`: String, mapper: (
    id: String,
    sourceId: String,
    name: String,
    streamUrl: String,
    coverUrl: String?,
    plot: String?,
    genre: String?,
    duration: Long?,
    rating: Double?,
    groupName: String?,
  ) -> T): Query<T> = SearchQuery(value) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7),
      cursor.getDouble(8),
      cursor.getString(9)
    )
  }

  public fun search(value_: String): Query<VodItemEntity> = search(value_) { id, sourceId, name,
      streamUrl, coverUrl, plot, genre, duration, rating, groupName ->
    VodItemEntity(
      id,
      sourceId,
      name,
      streamUrl,
      coverUrl,
      plot,
      genre,
      duration,
      rating,
      groupName
    )
  }

  public fun <T : Any> pageFiltered(
    group: String?,
    query: String?,
    limit: Long,
    offset: Long,
    mapper: (
      id: String,
      sourceId: String,
      name: String,
      streamUrl: String,
      coverUrl: String?,
      plot: String?,
      genre: String?,
      duration: Long?,
      rating: Double?,
      groupName: String?,
    ) -> T,
  ): Query<T> = PageFilteredQuery(group, query, limit, offset) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7),
      cursor.getDouble(8),
      cursor.getString(9)
    )
  }

  public fun pageFiltered(
    group: String?,
    query: String?,
    limit: Long,
    offset: Long,
  ): Query<VodItemEntity> = pageFiltered(group, query, limit, offset) { id, sourceId, name,
      streamUrl, coverUrl, plot, genre, duration, rating, groupName ->
    VodItemEntity(
      id,
      sourceId,
      name,
      streamUrl,
      coverUrl,
      plot,
      genre,
      duration,
      rating,
      groupName
    )
  }

  public fun countFiltered(group: String?, query: String?): Query<Long> = CountFilteredQuery(group,
      query) { cursor ->
    cursor.getLong(0)!!
  }

  public fun insert(
    id: String,
    sourceId: String,
    name: String,
    streamUrl: String,
    coverUrl: String?,
    plot: String?,
    genre: String?,
    duration: Long?,
    rating: Double?,
    groupName: String?,
  ) {
    driver.execute(-2_091_000_613, """
        |INSERT OR REPLACE INTO VodItemEntity(id, sourceId, name, streamUrl, coverUrl, plot, genre, duration, rating, groupName)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 10) {
          bindString(0, id)
          bindString(1, sourceId)
          bindString(2, name)
          bindString(3, streamUrl)
          bindString(4, coverUrl)
          bindString(5, plot)
          bindString(6, genre)
          bindLong(7, duration)
          bindDouble(8, rating)
          bindString(9, groupName)
        }
    notifyQueries(-2_091_000_613) { emit ->
      emit("VodItemEntity")
    }
  }

  public fun deleteBySourceId(sourceId: String) {
    driver.execute(-1_342_906_438, """DELETE FROM VodItemEntity WHERE sourceId = ?""", 1) {
          bindString(0, sourceId)
        }
    notifyQueries(-1_342_906_438) { emit ->
      emit("VodItemEntity")
    }
  }

  public fun deleteAll() {
    driver.execute(1_232_220_820, """DELETE FROM VodItemEntity""", 0)
    notifyQueries(1_232_220_820) { emit ->
      emit("VodItemEntity")
    }
  }

  private inner class SelectBySourceIdQuery<out T : Any>(
    public val sourceId: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("VodItemEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("VodItemEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(505_109_963,
        """SELECT VodItemEntity.id, VodItemEntity.sourceId, VodItemEntity.name, VodItemEntity.streamUrl, VodItemEntity.coverUrl, VodItemEntity.plot, VodItemEntity.genre, VodItemEntity.duration, VodItemEntity.rating, VodItemEntity.groupName FROM VodItemEntity WHERE sourceId = ?""",
        mapper, 1) {
      bindString(0, sourceId)
    }

    override fun toString(): String = "VodItem.sq:selectBySourceId"
  }

  private inner class SelectByGroupQuery<out T : Any>(
    public val groupName: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("VodItemEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("VodItemEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null,
        """SELECT VodItemEntity.id, VodItemEntity.sourceId, VodItemEntity.name, VodItemEntity.streamUrl, VodItemEntity.coverUrl, VodItemEntity.plot, VodItemEntity.genre, VodItemEntity.duration, VodItemEntity.rating, VodItemEntity.groupName FROM VodItemEntity WHERE groupName ${ if (groupName == null) "IS" else "=" } ?""",
        mapper, 1) {
      bindString(0, groupName)
    }

    override fun toString(): String = "VodItem.sq:selectByGroup"
  }

  private inner class SearchQuery<out T : Any>(
    public val `value`: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("VodItemEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("VodItemEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_813_545_014,
        """SELECT VodItemEntity.id, VodItemEntity.sourceId, VodItemEntity.name, VodItemEntity.streamUrl, VodItemEntity.coverUrl, VodItemEntity.plot, VodItemEntity.genre, VodItemEntity.duration, VodItemEntity.rating, VodItemEntity.groupName FROM VodItemEntity WHERE name LIKE '%' || ? || '%'""",
        mapper, 1) {
      bindString(0, value)
    }

    override fun toString(): String = "VodItem.sq:search"
  }

  private inner class PageFilteredQuery<out T : Any>(
    public val group: String?,
    public val query: String?,
    public val limit: Long,
    public val offset: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("VodItemEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("VodItemEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT VodItemEntity.id, VodItemEntity.sourceId, VodItemEntity.name, VodItemEntity.streamUrl, VodItemEntity.coverUrl, VodItemEntity.plot, VodItemEntity.genre, VodItemEntity.duration, VodItemEntity.rating, VodItemEntity.groupName FROM VodItemEntity
    |WHERE (? IS NULL OR groupName ${ if (group == null) "IS" else "=" } ?)
    |  AND (? IS NULL OR name LIKE '%' || ? || '%')
    |ORDER BY name
    |LIMIT ? OFFSET ?
    """.trimMargin(), mapper, 6) {
      bindString(0, group)
      bindString(1, group)
      bindString(2, query)
      bindString(3, query)
      bindLong(4, limit)
      bindLong(5, offset)
    }

    override fun toString(): String = "VodItem.sq:pageFiltered"
  }

  private inner class CountFilteredQuery<out T : Any>(
    public val group: String?,
    public val query: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("VodItemEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("VodItemEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT COUNT(*) FROM VodItemEntity
    |WHERE (? IS NULL OR groupName ${ if (group == null) "IS" else "=" } ?)
    |  AND (? IS NULL OR name LIKE '%' || ? || '%')
    """.trimMargin(), mapper, 4) {
      bindString(0, group)
      bindString(1, group)
      bindString(2, query)
      bindString(3, query)
    }

    override fun toString(): String = "VodItem.sq:countFiltered"
  }
}
